import React, { useRef, ChangeEvent } from 'react'
import { isNil } from '../../utils'
import { Icon } from '../../components/Icons/Icon'
import { useKeybind } from 'app/shared/hooks'

type Props = {
  onSearch: (event: string) => void
  onClick?: () => void
  placeholder?: string
  autoFocus?: boolean
  defaultValue?: string
}

export const Search = ({ onSearch, ...props }: C<Props>) => {
  const ref = useRef<HTMLInputElement>(null)

  const placeholder = props.placeholder ? props.placeholder : 'Search'

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    onSearch(event?.target?.value)
  }

  return (
    <div className='flex flex-1'>
      <div className='md:ml-0 flex w-full'>
        <label htmlFor='search_field' className='sr-only'>
          Search
        </label>
        <div className='focus-within:text-gray-600 relative w-full text-gray-400'>
          <div className='absolute inset-y-0 left-0 flex items-center ml-2 pointer-events-none'>
            <Icon iconName='search' />
          </div>
          <input
            onFocus={props.onClick}
            ref={ref}
            id='search_field'
            onChange={handleInput}
            defaultValue={props.defaultValue || ''}
            autoFocus={props.autoFocus}
            autoComplete='off'
            className='focus:outline-none focus:placeholder-gray-400 sm:text-sm block w-full h-full py-4 pl-8 pr-3 text-gray-900 placeholder-gray-500 rounded-md'
            placeholder={`${placeholder}`}
            type='search'
          />
        </div>
      </div>
    </div>
  )
}
